export default "__VITE_ASSET__wDqC1Q_1__"